export default __webpack_public_path__ + "2b6392095efe1e0d4e68aa6eec4e3495.svg";